exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-card{border:1px solid #ccc;height:auto;padding:20px 30px;margin-bottom:20px;border-radius:5px;-webkit-box-shadow:0px 3px 5px 0px #ccc;box-shadow:0px 3px 5px 0px #ccc}.with-card h4,.with-card h5{color:var(--text-light-blue);padding-bottom:15px;font-size:22px}@media only screen and (max-width: 768px){.with-card{padding:15px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/withCard/withCard.scss
// module id = 862
// module chunks = 0